import React, { useEffect, useState } from "react";
import {
  CircularAvatar,
  CommonHeader,
  ConfirmationModal,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../components/commons";
import { SearchIcon } from "../../../components/Icon";
import { RootState } from "../../../redux/rootReducers";
import { resetSession } from "../../../redux/auth";
import { connect } from "react-redux";
import Select from "react-select";
import {
  createMasterHolidayCalenderAction,
  deleteHolidayCalenderAction,
  getAllCountryAction,
  getAllMasterDataBranchAction,
  getMasterDataHolidayCalenderAction,
  resetHolidayCalenderList,
  resetHolidayCalenderTotalCount,
  resetMasterError,
  resetMasterMessage,
  resetMasterStatusCode,
  resetMasterSuccess,
  updateMasterDataHolidayCalenderAction,
} from "../../../redux/masterData";
import { components } from "react-select";
import useDebounce from "../../../customHooks/useDebounce";
import { EmptyList } from "../../../assets/images";
import HolidayCalenderTable from "../../../components/MasterData/HolidayCalenderTable/HolidayCalenderTable";
import toast, { Toaster } from "react-hot-toast";
import AddEditHolidayCalender from "./AddEditHolidayCalender";
import { handleDate, formatDate } from "../../../utils/commonFunctions";
import {
  CountryListTypes,
  HolidayCalenderListType,
} from "../../../redux/masterData/masterTypes";
import {
  CreateHolidayCalenderPayloadType,
  DeleteHolidayCalenderPayloadType,
  GetAllMasterDataBranchPayloadType,
  GetCountryListDataPayloadType,
  GetHolidayCalenderPayloadType,
  UpdateHolidayCalenderPayloadType,
} from "../../../commonTypes/masterDataTypes";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import { DropDownUserType } from "../../Jobs/RecurringJobReport";
import HolidayCalenderFilter from "../../../components/MasterData/HolidayCalenderTable/HolidayCalenderFilter";
export type DropDownType = {
  value: string | null | number;
  label: string;
};

type AppProps = {
  history: any;
  fetching: boolean;
  branchFetching: boolean;
  branchDataList: any;
  masterDataBranchListTotal: string | number;
  message: string;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  isOpen: boolean;
  branchHeaders: [];
  token: null | string;
  holidayCalenderList: HolidayCalenderListType[] | [];
  countryList: CountryListTypes[] | [];
  countryListTotalCount: number;
  countryFetching: boolean;
  holidayCalenderTotalCount: number;
  dispatchResetSession: () => void;
  dispatchGetCountryListAction: (data: GetCountryListDataPayloadType) => void;
  dispatchResetMasterStatusCode: () => void;
  dispatchResetMasterSuccess: () => void;
  dispatchResetMasterMessage: () => void;
  dispatchResetMasterError: () => void;
  dispatchResetMasterDataHolidayCalenderListing: () => void;
  dispatchResetMasterDataHolidayCalenderListTotal: () => void;
  dispatchGetMasterDataHolidayCalenderAction: (
    data: GetHolidayCalenderPayloadType
  ) => void;
  dispatchAddMasterHolidayCalender: (
    data: CreateHolidayCalenderPayloadType
  ) => void;
  dispatchUpdateMasterDataHolidayCalender: (
    data: UpdateHolidayCalenderPayloadType
  ) => void;
  dispatchDeleteHolidayCalenderAction: (
    data: DeleteHolidayCalenderPayloadType
  ) => void;
  dispatchGetAllMasterDataBranchListAction: (
    data: GetAllMasterDataBranchPayloadType
  ) => void;
};
const HolidayCalender = ({
  token,
  error,
  success,
  branchFetching,
  branchDataList,
  masterDataBranchListTotal,
  message,
  fetching,
  statusCode,
  countryList,
  countryFetching,
  holidayCalenderList,
  countryListTotalCount,
  holidayCalenderTotalCount,
  dispatchResetSession,
  dispatchResetMasterError,
  dispatchResetMasterSuccess,
  dispatchResetMasterMessage,
  dispatchResetMasterStatusCode,
  dispatchGetCountryListAction,
  dispatchAddMasterHolidayCalender,
  dispatchResetMasterDataHolidayCalenderListing,
  dispatchResetMasterDataHolidayCalenderListTotal,
  dispatchGetMasterDataHolidayCalenderAction,
  dispatchUpdateMasterDataHolidayCalender,
  dispatchDeleteHolidayCalenderAction,
  dispatchGetAllMasterDataBranchListAction,
}: AppProps) => {
  const [countryListSelected, setCountryListSelected] = useState<DropDownType>({
    value: "IN",
    label: "India",
  });
  const [showAddEditHolidayCalenderModal, setShowAddEditHolidayCalenderModal] =
    useState<boolean>(false);
  const [loadCondition, setLoadCondition] = useState(true);

  const [clearSearchText, setClearSearchText] = useState(false);
  const [finalCountryList, setFinalCountryList] = useState<any[] | []>([]);

  const [text, setText] = useState("");
  const [internalOffset, setInternalOffset] = useState(0);
  const [offset, setOffset] = useState(0);
  const [data, setData] = useState<HolidayCalenderListType[] | []>([]);
  const [searchValue, setSearchValue] = useState("");
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [id, setId] = useState<string | null | undefined>(null);
  const [branchOffset, setBranchOffset] = useState<number>(0);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [date, setDate] = useState("");
  const [limit, setLimit] = useState(20);
  const [description, setDescription] = useState<string>("");
  const [branchText, setBranchText] = useState<string>("");
  const [subDescription,setSubDescription]=useState<string>("")
  const [finalBranchDataList, setFinalBranchDataList] = useState<any>([]);
  const [clearFilter, setClearFilter] = useState(false);
  const [listBranch, setListBranch] = useState<DropDownUserType>({
    value: null,
    label: "Select...",
  });
  const [activeListBranch, setActiveListBranch] = useState<DropDownUserType>({
    value: null,
    label: "Select...",
  });
  const [branch, setBranch] = useState<DropDownUserType[]>([
    {
      value: null,
      label: "All Branches",
    },
  ]);
  const [toggleFilter, setToggleFilter] = useState<boolean>(false);
  const [countryListDropdownSelected, setCountryListDropDownSelected] =
    useState<DropDownType>({
      value: "IN",
      label: "India",
    });
  const [refresh, setRefresh] = useState<boolean>(false);

  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  const [deleteHolidayCalender, setDeleteHolidayCalender] = useState<number>(0);
  const [remove, setRemove] = useState<boolean>(false);
  //====================User Management=============================
  const [isAddHolidayCalenderPresent, setIsAddHolidayCalenderPresent] =
    useMenuCheck();
  const [isUpdateHolidayCalenderPresent, setIsUpdateHolidayCalenderPresent] =
    useMenuCheck();
  const [isDeleteHolidayCalenderPresent, setIsDeleteHolidayCalenderPresent] =
    useMenuCheck();

  //=================================================================

  useEffect(() => {
    dispatchResetMasterSuccess();
    dispatchResetMasterError();
    dispatchResetMasterMessage();
    dispatchResetMasterDataHolidayCalenderListing();
    dispatchResetMasterDataHolidayCalenderListTotal();
    dispatchResetMasterStatusCode();
    setIsAddHolidayCalenderPresent("Add Holiday", "menu");
    setIsUpdateHolidayCalenderPresent("Update Holiday", "menu");
    setIsDeleteHolidayCalenderPresent("Delete Holiday", "menu");
  }, []);

  useEffect(() => {
    if (holidayCalenderList?.length === 0) {
      setData(holidayCalenderList);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...holidayCalenderList]);
    } else {
      setData(holidayCalenderList);
    }
  }, [holidayCalenderList]);

  useEffect(() => {
    if (token) {
      let finalData: GetHolidayCalenderPayloadType = {
        token,
        limit,
        offset,
        searchValue,
        country: countryListSelected?.label,
        branch_id_filter: listBranch?.value?.toString(),
      };
      if (holidayCalenderTotalCount) {
        if (offset < holidayCalenderTotalCount) {
          dispatchGetMasterDataHolidayCalenderAction(finalData);
        }
      } else {
        dispatchGetMasterDataHolidayCalenderAction(finalData);
      }
    }
  }, [offset]);

  useDebounce(
    () => {
      if (searchValue) {
        fetchNewData();
      } else {
        dispatchResetMasterDataHolidayCalenderListing();
        let finalData: GetHolidayCalenderPayloadType = {
          token,
          limit,
          offset,
          searchValue,
          country: countryListSelected?.label,
          branch_id_filter: listBranch?.value?.toString(),
        };
        dispatchGetMasterDataHolidayCalenderAction(finalData);
      }
    },
    500,
    [searchValue]
  );

  useEffect(() => {
    dispatchResetMasterDataHolidayCalenderListing();
    if (remove) {
      const finaldata = {
        token,
        limit,
        offset,
        searchValue,
        country: countryListSelected?.label,
        branch_id_filter: listBranch?.value?.toString(),
      };
      dispatchGetMasterDataHolidayCalenderAction(finaldata);
    }
  }, [remove]);

  useEffect(() => {
    dispatchResetMasterDataHolidayCalenderListing();
    let finalData: GetHolidayCalenderPayloadType = {
      token,
      limit,
      offset,
      searchValue,
      country: countryListSelected?.label,
      branch_id_filter: listBranch?.value?.toString(),
    };
    if (offset === 0) {
      dispatchGetMasterDataHolidayCalenderAction(finalData);
    } else {
      setOffset(0);
    }
    // dispatchGetMasterDataHolidayCalenderAction(finalData);
  }, [countryListSelected?.value]);

  useEffect(() => {
    if (!showAddEditHolidayCalenderModal) {
      setIsEdit(false);
    }
  }, [showAddEditHolidayCalenderModal]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: branchOffset,
        limit,
        search_term: text,
        branch_status: 1,
      };
      if (offset <= +masterDataBranchListTotal) {
        dispatchGetAllMasterDataBranchListAction(finalUserData);
      }
    }
  }, [branchOffset]);

  useEffect(() => {
    const branchData = branchDataList?.map((data: any) => {
      return {
        value: data?._id,
        label: data?.branch_name,
      };
    });
    if (branchOffset > 0) {
      setFinalBranchDataList([...finalBranchDataList, ...branchData]);
    } else {
      setFinalBranchDataList(branchData);
    }
  }, [branchDataList]);

  const fetchNewBranchData = (search: string) => {
    const finalData = {
      token,
      offset: branchOffset,
      limit,
      search_term: branchText,
      branch_status: 1,
    };
    dispatchGetAllMasterDataBranchListAction(finalData);
  };

  const checkBranchBottom = (e: any) => {
    setLoadCondition(false);
    setBranchOffset((prv: any) => prv + limit);
  };

  useDebounce(
    () => {
      if (branchText) {
        fetchNewBranchData(branchText);
      } else {
        const finalData = {
          token,
          offset: branchOffset,
          limit,
          search_term: branchText,
          branch_status: 1,
        };
        dispatchGetAllMasterDataBranchListAction(finalData);
      }
    },
    500,
    [branchText]
  );

  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setBranchOffset((prv: any) => prv + limit);
  };

  const fetchNewData = () => {
    dispatchResetMasterDataHolidayCalenderListing();
    if (token) {
      let finalData = {
        token,
        searchValue,
        limit,
        offset: branchOffset,
        country: countryListSelected?.label,
        branch_id_filter: listBranch?.value?.toString(),
      };
      if (offset === 0) {
        dispatchGetMasterDataHolidayCalenderAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  useEffect(() => {
    if (listBranch?.value) {
      fetchNewData();
    }
  }, [listBranch]);
  useEffect(() => {
    if (clearFilter) {
      fetchNewData();
    }
  }, [clearFilter]);
  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchValue(value);

    if (value?.length === 0) {
      let finalData = {
        offset: 0,
        limit,
        token,
        country: countryListSelected?.label,
        branch_id_filter: listBranch?.value?.toString(),
      };
      dispatchGetMasterDataHolidayCalenderAction(finalData);
    }
  };

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < holidayCalenderTotalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (holidayCalenderList?.length > 0) {
          if (!fetching && offset < holidayCalenderTotalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [holidayCalenderList]);

  useEffect(() => {
    if (offset === 0) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
      setOffset(0);
    }
  }, [success]);

  const toggleAddEditHolidayCalenderModal = () => {
    if (!showAddEditHolidayCalenderModal) {
      handleResetData();
    }

    setShowAddEditHolidayCalenderModal(!showAddEditHolidayCalenderModal);
  };
  const handleResetData = () => {
    setDate("");
    setDescription("");
    setSubDescription("")
    setOffset(0);
    setBranch([
      {
        value: null,
        label: "All Branches",
      },
    ]);
  };
  const handleDateChange = (date: string) => {
    const value = handleDate(date);
    setDate(value);
  };
  const handleDescriptionChange = (e: any) => {
    setDescription(e.target.value);
  };

  const handleSubDescriptionChange= (e: any) => {
    setSubDescription(e.target.value);
  };

  const handleBranchDropDownChange = (selectedOptions: any) => {
    if(branch?.find((item)=>item?.value===null)){
      selectedOptions= selectedOptions?.filter((item:any)=>item?.value!=null)
    }else if(branch?.length>=1 && selectedOptions?.find((item:any)=>item?.value===null)){
      selectedOptions= selectedOptions?.filter((item:any)=>item?.value===null)
    }
    setBranch(selectedOptions);
  };

  const handleListBranchDropDownChange = (selectedOptions: any) => {
    setListBranch(selectedOptions);
    dispatchResetMasterDataHolidayCalenderListing();
    let finalData: GetHolidayCalenderPayloadType = {
      token,
      limit,
      offset,
      searchValue,
      country: countryListSelected?.label,
      branch_id_filter: selectedOptions?.value,
    };
    if (offset === 0) {
      dispatchGetMasterDataHolidayCalenderAction(finalData);
    } else {
      setOffset(0);
    }
  };

  useEffect(() => {
    if (token) {
      let finalCountryData = {
        token,
        offset: internalOffset,
        limit,
        search_term: text,
      };
      if (offset <= +countryListTotalCount) {
        dispatchGetCountryListAction(finalCountryData);
      }
    }
  }, [internalOffset]);

  useEffect(() => {
    const countryData = countryList?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (internalOffset > 0) {
      setFinalCountryList([...finalCountryList, ...countryData]);
    } else {
      setFinalCountryList(countryData);
    }
  }, [countryList]);

  const fetchInternalNewData = (search: string) => {
    setClearSearchText(true);
    const finalData = {
      token,
      offset: internalOffset,
      limit,
      search_term: text,
    };
    if (internalOffset === 0) {
      dispatchGetCountryListAction(finalData);
    } else {
      setInternalOffset(0);
    }
  };

  useEffect(() => {
    if (clearSearchText) {
      const finalData = {
        token,
        offset: internalOffset,
        limit,
        search_term: text,
      };
      if (text?.length === 0) {
        dispatchGetCountryListAction(finalData);
        setInternalOffset(0);
      }
    }
  }, [clearSearchText, text]);

  useDebounce(
    () => {
      if (text) {
        fetchInternalNewData(text);
      }
    },
    500,
    [text]
  );

  const handleChangeCountry = (data: any) => {
    setCountryListSelected({
      value: data?.value,
      label: data?.label,
    });
  };

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };
  const checkBottomInternal = (e: any) => {
    setLoadCondition(false);
    setInternalOffset((prv) => prv + limit);
  };
  const onMenuClose = () => {
    setLoadCondition(true);
    setInternalOffset(0);
  };

  const handleSuccessMessage = (type: string) => {
    switch (type) {
      case "created-master-holiday-calender":
        return setSuccessMessage(
          "Holiday calendar has been added successfully!"
        );
      case "update-master-holiday-calender":
        return setSuccessMessage(
          "Holiday calendar has been updated successfully!"
        );
      case "delete-master-holiday-calender":
        return setSuccessMessage(
          "Holiday calender data has been deleted successfully!"
        );
      default:
        return setSuccessMessage("");
    }
  };
  const handleAddHoliday = () => {
    const branchSelected: string[] = branch
  ?.map((item) => item?.value?.toString()) // Convert all values to strings
  .filter((value): value is string => Boolean(value)); 

    setRefresh(!refresh);
    dispatchResetMasterDataHolidayCalenderListing();
    dispatchResetMasterStatusCode();
    if (isEdit) {
      let updateData = {
        token: token,
        date: formatDate(date),
        country: countryListDropdownSelected?.label,
        description: description,
        _id: id,
        branch: branchSelected?.length > 0 ? branchSelected : [],
        subDescription
      };
      dispatchUpdateMasterDataHolidayCalender(updateData);
      handleSuccessMessage("update-master-holiday-calender");
    } else {
      let finalAddData = {
        token,
        date: formatDate(date),
        country: countryListDropdownSelected?.label,
        description: description,
        branch: branchSelected?.length > 0 ? branchSelected : [],
        subDescription
      };
      dispatchAddMasterHolidayCalender(finalAddData);
      handleSuccessMessage("created-master-holiday-calender");
      setSearchValue("");
    }
  };
  const handleEditMasterHolidayCalender = (data: any) => {
    setIsEdit(true);
    setShowAddEditHolidayCalenderModal(true);
    setDate(data?.date);
    setDescription(data?.description);
    setSubDescription(data?.sub_description)
    setBranch([
      ...data?.branches?.map((item: any) => ({
        label: item?.branch_name,
        value: item?._id,
      })),
    ]);
    setCountryListDropDownSelected({
      value: data?.country,
      label: data?.country,
    });
    setId(data?._id);
  };

  const handleShowConfirmationModal = (id: number) => {
    setShowConfirmationModal(!showConfirmationModal);
    setDeleteHolidayCalender(id);
  };

  const handleDeleteHolidayCalender = (id: any) => {
    let finalData = {
      id,
      token,
    };
    dispatchDeleteHolidayCalenderAction(finalData);
    handleSuccessMessage("delete-master-holiday-calender");

    setRemove(true);
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetMasterError();
            }}
          />
        );
      }
    }
    if (success === 1 && message?.includes("added successfully!")) {
      dispatchResetMasterDataHolidayCalenderListing();
      dispatchResetMasterSuccess();
      dispatchResetMasterMessage();
      toast.success(successMessage, {
        duration: 2000,
      });
      if (token) {
        let finalData = {
          token,
          limit,
          offset: 0,
          searchValue,
          country: countryListSelected?.label,
          branch_id_filter: listBranch?.value?.toString(),
        };
        if (offset === 0) {
          dispatchGetMasterDataHolidayCalenderAction(finalData);
        } else {
          setOffset(0);
        }
      }
    }
    if (success === 1 && message?.includes("updated successfully!")) {
      dispatchResetMasterDataHolidayCalenderListing();
      dispatchResetMasterSuccess();
      dispatchResetMasterMessage();
      toast.success(successMessage, {
        duration: 2000,
      });
      if (token) {
        let finalData = {
          token,
          limit,
          offset,
          searchValue,
          country: countryListSelected?.label,
          branch_id_filter: listBranch?.value?.toString(),
        };
        if (offset === 0) {
          dispatchGetMasterDataHolidayCalenderAction(finalData);
        }
      }
    }

    if (success === 1 && message?.includes("deleted successfully!")) {
      dispatchResetMasterDataHolidayCalenderListing();
      dispatchResetMasterSuccess();
      dispatchResetMasterMessage();
      toast.success(successMessage, {
        duration: 2000,
      });
      if (token) {
        let finalData = {
          token,
          limit,
          offset,
          searchValue,
          country: countryListSelected?.label,
          branch_id_filter: listBranch?.value?.toString(),
        };
        if (offset === 0) {
          dispatchGetMasterDataHolidayCalenderAction(finalData);
        }
      }
    }

    return false;
  };
  return (
    <div className="row">
      <div className="col-md-6">
        <CommonHeader title="Holiday Calendar" />
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div className="header pb-0">
            <div className="left-header">
              <div className="heading">Holiday Calendar List</div>
              {(
                <div
                  className="sub-heading"
                  style={{ marginTop: "-22px" }}
                >{`Total ${
                  holidayCalenderTotalCount ? holidayCalenderTotalCount : 0
                } entries found`}</div>
              )}
            </div>
            <div className="right-header">
              <div
                className={`${
                  !!holidayCalenderList?.length ? "col-md-5" : "col-md-5"
                } position-relative`}
              >
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={(e) => handleSearch(e)}
                  style={{ paddingLeft: "35px" }}
                  value={searchValue}
                />
              </div>

              <HolidayCalenderFilter
                setListBranch={setListBranch}
                listBranch={listBranch}
                setActiveListBranch={setActiveListBranch}
                activeListBranch={activeListBranch}
                setClearFilter={setClearFilter}
                setOffset={setBranchOffset}
                finalBranchDataList={finalBranchDataList}
                branch={branch}
                handleBranchDropDownChange={handleBranchDropDownChange}
                branchFetching={branchFetching}
                setBranchText={setBranchText}
                checkBottom={checkBranchBottom}
                toggle={toggleFilter}
                setToggle={setToggleFilter}
              />

              {isAddHolidayCalenderPresent && (
                <button
                  className="btn btn-primary ml-2"
                  onClick={toggleAddEditHolidayCalenderModal}
                >
                  + Add Holiday Calendar
                </button>
              )}
            </div>
          </div>
          <div className="d-flex">
            <div className="col-md-3 mt-3 mb-3">
              <label className="mb-1" htmlFor="">
                Country
              </label>
              <Select
                onMenuClose={onMenuClose}
                value={countryListSelected}
                isSearchable={true}
                options={finalCountryList}
                components={{ Option }}
                onChange={(e) => handleChangeCountry(e)}
                onMenuScrollToBottom={(e: any) => checkBottomInternal(e)}
                onInputChange={(e: string) => {
                  setLoadCondition(false);
                  setText(e);
                  // setInternalOffset(0)
                }}
                isLoading={countryFetching}
              />
            </div>
          </div>
          {(fetching && offset == 0 && !showAddEditHolidayCalenderModal && !toggleFilter) ? (
            <TableLoader Rows={10} ColumnPerRow={7} />
          ) : holidayCalenderList?.length > 0 ? (
            <HolidayCalenderTable
              data={data}
              fetching={fetching}
              offset={offset}
              handleEditMasterHolidayCalender={handleEditMasterHolidayCalender}
              handleDeleteHolidayCalender={handleDeleteHolidayCalender}
              handleShowConfirmationModal={handleShowConfirmationModal}
              isUpdateHolidayCalenderPresent={isUpdateHolidayCalenderPresent}
              isDeleteHolidayCalenderPresent={isDeleteHolidayCalenderPresent}
            />
          ) : (
            <div className="mt-5 pb-5">
              {!fetching && data?.length === 0 && (
                <EmptyListPage
                  title="No List Found!"
                  image={EmptyList}
                  imageWidth="30%"
                />
              )}
            </div>
          )}
        </div>
      </div>
      {showAddEditHolidayCalenderModal && (
        <AddEditHolidayCalender
          showAddEditHolidayCalenderModal={showAddEditHolidayCalenderModal}
          toggleAddEditHolidayCalenderModal={toggleAddEditHolidayCalenderModal}
          isEdit={isEdit}
          date={date}
          handleDateChange={handleDateChange}
          description={description}
          handleAddHoliday={handleAddHoliday}
          handleDescriptionChange={handleDescriptionChange}
          token={token}
          countryListTotalCount={countryListTotalCount}
          dispatchGetCountryListAction={dispatchGetCountryListAction}
          countryList={countryList}
          countryFetching={countryFetching}
          countryListDropdownSelected={countryListDropdownSelected}
          setCountryListDropDownSelected={setCountryListDropDownSelected}
          offset={offset}
          finalBranchDataList={finalBranchDataList}
          branch={branch}
          handleBranchDropDownChange={handleBranchDropDownChange}
          branchFetching={branchFetching}
          setBranchText={setBranchText}
          setBranchoffset={setBranchOffset}
          subDescription={subDescription}
          handleSubDescriptionChange={handleSubDescriptionChange}
        />
      )}
      {showConfirmationModal && (
        <ConfirmationModal
          toggle={() => {
            handleShowConfirmationModal(deleteHolidayCalender);
          }}
          isOpen={showConfirmationModal}
          title={"Delete Holiday Calendar"}
          message={`Are you sure? you want to Delete`}
          confirmButtonText={"Delete"}
          onPressConfirm={() => {
            handleDeleteHolidayCalender(deleteHolidayCalender);
            handleShowConfirmationModal(deleteHolidayCalender);
          }}
        />
      )}
      {handleErrorModal()}
      <Toaster />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.masterData.fetching,
  statusCode: state.masterData.statusCode,
  error: state.masterData.error,
  emailerList: state.masterData.emailerList,
  emailListTotalCount: state.masterData.emailListTotalCount,
  success: state.masterData.success,
  message: state.masterData.message,
  holidayCalenderTotalCount: state.masterData.holidayCalenderTotalCount,
  holidayCalenderList: state.masterData.holidayCalenderList,
  countryList: state.masterData.countryList,
  countryListTotalCount: state.masterData.countryListTotalCount,
  countryFetching: state.masterData.countryFetching,
  branchFetching: state.masterData.fetching,
  branchDataList: state.masterData.masterDataListing,
  masterDataBranchListTotal: state.masterData.masterDataBranchListTotal,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetCountryListAction: (data: GetCountryListDataPayloadType) =>
    dispatch(getAllCountryAction(data)),
  dispatchAddMasterHolidayCalender: (data: CreateHolidayCalenderPayloadType) =>
    dispatch(createMasterHolidayCalenderAction(data)),
  dispatchUpdateMasterDataHolidayCalender: (
    data: UpdateHolidayCalenderPayloadType
  ) => {
    dispatch(updateMasterDataHolidayCalenderAction(data));
  },
  dispatchGetAllMasterDataBranchListAction: (
    data: GetAllMasterDataBranchPayloadType
  ) => {
    dispatch(getAllMasterDataBranchAction(data));
  },
  dispatchDeleteHolidayCalenderAction: (
    data: DeleteHolidayCalenderPayloadType
  ) => dispatch(deleteHolidayCalenderAction(data)),
  dispatchGetMasterDataHolidayCalenderAction: (
    data: GetHolidayCalenderPayloadType
  ) => dispatch(getMasterDataHolidayCalenderAction(data)),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
  dispatchResetMasterDataHolidayCalenderListing: () =>
    dispatch(resetHolidayCalenderList()),
  dispatchResetMasterDataHolidayCalenderListTotal: () =>
    dispatch(resetHolidayCalenderTotalCount()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HolidayCalender);
